import { createSlice } from "@reduxjs/toolkit";
import { fetchGps, fetchGpById, updateGp, updateStatusInGp } from "./thunk";

interface GpState {
  gpList: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
  selectedGp: any;
}

const initialState: GpState = {
  gpList: [],
  rowCount: 0,
  loading: false,
  error: null,
  selectedGp: null,
};

const gpSlice = createSlice({
  name: "gp",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchGps.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchGps.fulfilled, (state, action) => {
        state.loading = false;
        state.gpList = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchGps.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch GPs";
      })
      .addCase(fetchGpById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchGpById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedGp = action.payload;
      })
      .addCase(fetchGpById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(updateGp.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.gpList = state.gpList.map((gp) =>
          gp.id === action.payload.id ? action.payload : gp
        );
      })
      .addCase(updateGp.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update GP";
      })
      .addCase(updateStatusInGp.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        // state.gpList = state.gpList.map((gp) =>
        //   gp.id === action.payload.id ? action.payload : gp
        // );
      })
      .addCase(updateStatusInGp.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update status";
      });
  },
});

export default gpSlice.reducer;
